(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-steps"] && !Shopify.designMode) return;
  try {
    
  const blocks = Array.from(document.querySelectorAll('.sticky-steps__content__section'));
  const stagesMedia = Array.from(document.querySelectorAll('#sticky-steps__images__container .step'));
  console.log('stagesMedia', stagesMedia);
  function setActive(idx) {
    stagesMedia.forEach((media, i) => {
      if (i === idx) media.classList.add('active');
      else media.classList.remove('active');
    });
  }

  const isMobile = window.innerWidth <= 768;

  if (!isMobile && stagesMedia.length > 0 && blocks.length > 0) {
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              const idx = +e.target.dataset.img;
              console.log('idx', idx);
              setActive(idx);
            }
          });
        },
        {
          root: null,
          threshold: 0.5,
          rootMargin: '0px'
        }
      );

      blocks.forEach((b) => io.observe(b));
    } else {
      function onScroll() {
        let bestIdx = 0,
          bestDist = Infinity;
        const mid = window.scrollY + window.innerHeight / 2;
        blocks.forEach((b, i) => {
          const r = b.getBoundingClientRect();
          const top = window.scrollY + r.top;
          const center = top + r.height / 2;
          const d = Math.abs(center - mid);
          if (d < bestDist) {
            bestDist = d;
            bestIdx = +b.dataset.img;
          }
        });
        setActive(bestIdx);
      }
      document.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const newIsMobile = window.innerWidth <= 768;
      if (newIsMobile !== isMobile) {
        location.reload();
      }
    }, 250);
  });

  } catch(e) { console.error(e); }
})();
})();
